// decision-ledger-merge-request-block.ts — V2-1 E11 (spec V2 §3 + §4.1).
//
// Dòng của khối "Quyết định trong mission" trong mô tả MR release: một dòng
// mỗi mục sổ (auto HOẶC người — kể cả mission `ask`). Sổ rỗng ⇒ `[]` ⇒ khối
// không in, mô tả MR = baseline. "Worker ghi nhận" (E13) không thuộc khối này
// — chỉ quyết định có thẩm quyền (máy theo G0, hoặc người). Khối KHÔNG vào
// release manifest hash (G3 / deploy hash không đổi — release-manifest-hash.ts).
// Redact: chuỗi đã qua redactor ở projection; toàn bộ mô tả còn qua
// SecretRedactor một lần nữa ở draft-merge-request-push.ts (known-values).
import { CHAT_DELEGATED_LABEL, isChatDelegatedActor } from "./chat-delegated-attribution.js";
import { replaceControlChars } from "./clip-untrusted-text.js";
import type { DecisionLedger, DecisionLedgerEntry } from "./decision-ledger-projection.js";

/** Một dòng, không ký tự điều khiển (review 03b M2) — cũng chặn giả trailer bằng `\r`. */
export function oneLine(text: string): string {
  return replaceControlChars(text.replace(/\s*\n\s*/g, " "));
}

/**
 * Review 03b L7: mô tả MR nằm trên remote cho mọi thành viên repo — mục máy giữ
 * `delegated:<G0 id>` (I6: phân biệt máy/người), mục người chỉ ghi "người"
 * (không user id / tài khoản OS). `status --decisions` (terminal local) vẫn in đủ.
 */
export function decisionChoiceAndSource(e: DecisionLedgerEntry): string {
  const choice = e.optionId === undefined ? e.optionLabel : `${e.optionId} (${e.optionLabel})`;
  // 06k C9: ủy nhiệm chat ⇒ nhãn cố định (không tài khoản OS), không bao giờ "người".
  const source =
    e.origin === "auto"
      ? e.source
      : isChatDelegatedActor(e.source)
        ? CHAT_DELEGATED_LABEL
        : "người";
  return `${choice} — nguồn ${source}`;
}

/** `QĐ-NN [T-xxxx]` — shared with the review prompt's ledger section (06f R4). */
export function decisionCodeAndTicket(e: DecisionLedgerEntry): string {
  return e.ticketId === undefined ? e.code : `${e.code} [${e.ticketId}]`;
}

function entryLine(e: DecisionLedgerEntry): string {
  const at = e.decidedAt === undefined ? "" : `, ${e.decidedAt}`;
  return oneLine(`${decisionCodeAndTicket(e)} ${e.question} → ${decisionChoiceAndSource(e)}${at}`);
}

export function decisionLedgerMergeRequestLines(ledger: DecisionLedger): string[] {
  return ledger.entries.map(entryLine);
}
